
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/decks/[...deckInfo]",
      function () {
        return require("private-next-pages/decks/[...deckInfo].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/decks/[...deckInfo]"])
      });
    }
  